import CollectionDataGrid from '@/components/CollectionDataGrid'
import { pbUpsert, useCollection } from '@/pb'
import { useInputState } from '@/utils'
import { Button, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'

const Editor = ({ row, onClose }) => {
  const [name, setName] = useInputState(row?.name)
  const [info, setInfo] = useInputState(row?.info)

  return <>
    <DialogTitle>Клиент</DialogTitle>
    <DialogContent className="editorForm">
      <TextField label="Название" value={name} onChange={setName} />
      <TextField label="Информация" value={info} onChange={setInfo} multiline />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} >Отмена</Button>
      <Button onClick={() => pbUpsert('music', { id: row?.id, name, info }).then(onClose)} variant="contained">Сохранить</Button>
    </DialogActions>
  </>
}

const columns = [
  { field: 'title', headerName: 'Название', width: 300 },
  { field: 'author', headerName: 'автор', width: 300 },
]

export default function Clients({ title }) {

  const [clients, loaded] = useCollection('music')

  return <>
    <CollectionDataGrid
      collectionName={title}
      collection={clients}
      columns={columns}
      loading={!loaded}
      editor={Editor}
    />
  </>

}